// Typed SDK for edge-signer (packages/edge-signer). See that package's src/index.js for the
// endpoint contracts — all routes live under /sign/*.
import { apiRequest } from './client.js';

export interface SignRecordRequest {
  audit_record_id: string;
  client_id: string;
  ends_at: string | null;
  kid: string;
  nonce: string;
  record_type: string;
  recorded_at: string;
  starts_at: string | null;
}

export interface SignRecordResponse {
  jws: string;
  payload: {
    audit_record_id: string;
    client_id: string;
    components: string;
    ends_at: string | null;
    record_type: string;
    signed_at: string;
    starts_at: string | null;
  };
}

export interface SignCombineRequest {
  audit_record_id: string;
  client_id: string;
  ends_at: string;
  kid: string;
  nonce: string;
  record_type: string;
  recorded_at: string;
  start_jws: string;
}

export interface SignAssignmentRequest {
  assignment_id: string;
  ends_at: string;
  kid: string;
  member_email: string;
  nonce: string;
  record_type: string;
  starts_at: string;
  workplace_label: string;
}

export const signerApi = {
  ping(): Promise<{ server_time: string }> {
    return apiRequest('signer', 'GET', '/sign/ping');
  },
  signAssignment(
    body: SignAssignmentRequest,
  ): Promise<{ jws: string; payload: Record<string, unknown> }> {
    return apiRequest('signer', 'POST', '/sign/assignment', { body });
  },
  signCombine(body: SignCombineRequest): Promise<SignRecordResponse> {
    return apiRequest('signer', 'POST', '/sign/combine', { body });
  },
  signRecord(body: SignRecordRequest): Promise<SignRecordResponse> {
    return apiRequest('signer', 'POST', '/sign/record', { body });
  },
  /** Always resolves (even for an invalid JWS) — server returns { valid: false, reason } rather
   * than a non-2xx status for a malformed/invalid signature. */
  verify(jws: string): Promise<{ reason?: string; valid: boolean }> {
    return apiRequest('signer', 'POST', '/sign/verify', { body: { jws } });
  },
};
